<app-x-icon-button [name]="'chevron-down'">

</app-x-icon-button>